import { createIcon } from './factory'
import Icon from './tray.svg?react'

export const Tray = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
